const getters = {
  loading(state) {
    return state.loading;
  },
  error(state) {
    return state.error;
  },
  errorMessage(state) {
    return state.errorMessage;
  },
  errorCode(state) {
    return state.errorCode;
  },
  isReferralFlow(state) {
    const isReferralFlow = state?.isReferralFlow || JSON.parse(localStorage.getItem('isReferralFlow'));
    return isReferralFlow;
  },
  isUpdateMobileNoFocusBlur(state) {
    return state.isUpdateMobileNoFocusBlur;
  },
  tokenData(state) {
    const tokenData = state?.tokenData || JSON.parse(localStorage.getItem('tokenData'));
    return tokenData;
  },
  uuid() {
    const uuid = JSON.parse(localStorage.getItem('tokenData'))?.sub;
    return uuid;
  },
};
export default getters;
